import type { LibraryItemResource } from '@studio/shared';

/**
 * How a piece of App Library material is named and how its state is said, in one place
 * so the App page and a Brief never describe the same item differently.
 */

export function materialName(item: LibraryItemResource): string {
  return item.originName ?? item.sourceUrl ?? item.role;
}

/**
 * R021. A link the Studio could not read is kept, and the operator is told once, plainly.
 *
 * This is not a failure waiting to be cleared up: the address is still what the Brief
 * selected, generation carries on with it, and a page capture can be added later if it
 * turns out to be worth one. Saying nothing was the actual behaviour of this build - the
 * warning was written to the database and never shown anywhere.
 */
export function retrievalNote(item: LibraryItemResource): string | null {
  if (item.retrievalState === 'pending') return 'Ещё читается.';
  if (item.retrievalState !== 'linkOnly') return null;
  const warning = item.retrievalWarning ?? 'С этого адреса ничего не удалось прочитать.';
  return `Только ссылка · ${warning} Её всё ещё можно использовать, а захват добавить позже.`;
}
